import { mode } from '@chakra-ui/theme-tools'

// https://github.com/chakra-ui/chakra-ui/blob/master/packages/theme/src/components/button.ts
export const Button = {
  baseStyle: {
    borderRadius: 'lg',
    fontWeight: '500',
    _focus: {
      boxShadow: 'none',
    },
  },

  variants: {
    solid: (props) => {
      return props.colorScheme === 'gray'
        ? {
            bg: mode(`gray.300`, `whiteAlpha.200`)(props),
            border: '1px',
            borderColor: 'transparent',
            _hover: { bg: mode(`gray.200`, `whiteAlpha.300`)(props) },
            _active: {
              bg: mode(`white`, `whiteAlpha.400`)(props),
              borderColor: 'gray.800',
              boxShadow: `outline-${props.colorScheme}`,
            },
          }
        : {
            _active: {
              boxShadow: `outline-${props.colorScheme}`,
            },
          }
    },
    outline: (props) => {
      return props.colorScheme === 'gray'
        ? {
            _active: {
              boxShadow: `outline-${props.colorScheme}`,
            },
          }
        : {
            color: mode(`${props.colorScheme}.500`, `${props.colorScheme}.200`)(props),
            _active: {
              boxShadow: `outline-${props.colorScheme}`,
            },
          }
    },
  },

  sizes: {
    md: {
      fontSize: 'sm',
    },
    lg: {
      fontSize: 'md',
    },
  },
}
